module.exports = __webpack_public_path__ + "static/img/przybornik_prostokat.5a18859a.png";